function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M12 5.999a4.5 4.5 0 004.5 4.5m0 0a4.5 4.5 0 00-4.5 4.5m0 0a4.5 4.5 0 00-4.5-4.5m0 0a4.5 4.5 0 004.5-4.5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M18 3H6a3 3 0 00-3 3v9a3 3 0 003 3h2.007v2.443a.556.556 0 00.903.434L12.507 18H18a3 3 0 003-3V6a3 3 0 00-3-3z",
  clipRule: "evenodd"
}));